import { render, staticRenderFns } from "./RelatedUsersModal.vue?vue&type=template&id=0323815e&"
import script from "./RelatedUsersModal.vue?vue&type=script&lang=js&"
export * from "./RelatedUsersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports